import React from "react";
import { NavLink } from "react-router-dom";
import { IDashboardRoute } from "../../../Interfaces/IDashboardRoute";
import { createStyles, Theme } from "@mui/material/styles";
import { useConfiguration } from "../../../Data/ConfigurationData";
// import { useQueryApplicationConfiguration } from "../../../Data/ApplicationData";
import { isAdmin } from '../../../utils/appUtils';
import { ILoggedInUser } from '../../../Interfaces/ILoggedInUser';
import { ListItem, ListItemText, ListItemIcon, Link } from "@mui/material";
import styles from './_sidebar.module.scss';

interface ISidebarProps {
  routes: IDashboardRoute[];
  currentUser?: ILoggedInUser;
}

const SideBar: React.FC<ISidebarProps> = (props: ISidebarProps) => {
  const { data: configuration } = useConfiguration();
  const canViewAdminPages = configuration?.isSuperUser || isAdmin(props.currentUser?.employee) === true;
  const userHasAccess = (route: IDashboardRoute): boolean => {
    if (route.publicRoute && !route.adminRoute) {
      return true;
    }
    if (route.adminRoute && canViewAdminPages) {
      return true;
    }
    if (route.superUserRoute && configuration?.isSuperUser) {
      return true;
    }

    return false;

  };
  // const { data } = useQueryApplicationConfiguration();

  const linkItemStyle = {
    transition: "all 300ms linear",
    textDecoration: "none"
  };


  return (
    <div className={styles.sideBarContainer}>
      {props.routes.map((r, key) =>
        r.showInSidebar && userHasAccess(r)
          ? (
            <React.Fragment key={key}>
              {/* {r.sidebarName === 'Application' && data
                ? (
                  <Link href={data.amsApplicationUri} key={r.path} target="_blank" rel="noopener" style={linkItemStyle}>
                    <ListItem key={r.path} component="label">
                      <ListItemIcon>
                        <r.icon />
                      </ListItemIcon>
                      <ListItemText className={styles.item} primary={r.sidebarName} />
                    </ListItem>
                  </Link>
                ) : */}
                <NavLink to={r.path} key={r.path} style={linkItemStyle}>
                  <ListItem key={r.path} component="label">
                    <ListItemIcon>
                      <r.icon />
                    </ListItemIcon>
                    <ListItemText className={styles.item} primary={r.sidebarName} />
                  </ListItem>
                </NavLink>

              {/* } */}
            </React.Fragment>
          )
          : (
            <div key={key}></div>
          )
      )}
    </div>
  );
};

export default SideBar;
